import { ChevronRightIcon, InviteMemberIcon } from '../../../../../assets/icons';
import { selectProfile } from '../../../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import styles from './style.module.scss';
import { useState } from 'react';
import {
    setExtraServiceDetail,
    setAddExtraMemberModal,
    setExtraServicesPaymentModal,
} from '../../../../../store/workspace/slice';

const landingUrl = process.env.REACT_APP_LANDING_URL;

const basePriceList = {
    free_trial: 0,
    standard_monthly: 20,
    standard_annual: 16,
    professional_monthly: 20,
    professional_annual: 16,
};

export default function AddExtraMember() {
    const dispatch = useDispatch();
    const [count, setCount] = useState(0);
    const profile = useSelector(selectProfile);
    const pricePerItem = basePriceList[profile?.planType || 'standard_monthly'];

    const openContactSales = () => {
        window.open(`${landingUrl}/book-demo`, '_blank');
    };

    const updateCount = (mode: 'Decrement' | 'Increment') => {
        if (!profile || Number.isNaN(profile.memberCounter)) return;

        switch (mode) {
            case 'Decrement': {
                if (count !== 0) {
                    setCount(prev => prev - 1);
                }
                break;
            }
            case 'Increment': {
                if (count < (5 - profile.memberCounter)) {
                    setCount(prev => prev + 1);
                }
                break;
            }
            default:
                return;
        }
    };

    const submit = () => {
        dispatch(setExtraServiceDetail({
            type: 'member',
            sub: count,
        }));

        dispatch(setAddExtraMemberModal(false));
        dispatch(setExtraServicesPaymentModal(true));
    };

    return (
        <Modal
            size='md'
            title='Add member seat'
            icon={<InviteMemberIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setAddExtraMemberModal(false))}
        >
            <h6>To add more, an additional member charge applies.</h6>

            <div className={styles.seat}>
                <div className={styles.seat_count}>
                    <b>{count}</b> Member account seat{count > 1 ? 's' : ''}
                </div>
                <div className={styles.seat_action}>
                    <div
                        className={styles.seat_action_btn}
                        onClick={() => updateCount('Decrement')}
                        data-is-deactive={count === 0}
                    >
                        <span>-</span>
                    </div>
                    <span>{count}</span>
                    <div
                        className={styles.seat_action_btn}
                        onClick={() => updateCount('Increment')}
                        data-is-deactive={count === (5 - (profile?.memberCounter || 0))}
                    >
                        <span>+</span>
                    </div>
                </div>
            </div>

            <div className={styles.calc}>
                <h6>${pricePerItem} per seat</h6>
                <h4>${count * (pricePerItem)}.00</h4>
            </div>

            {count === (5 - (profile?.memberCounter || 0)) && <div className={styles.info}>
                <h6>For more than 5 member seat you should contact sales!</h6>
                <div className={styles.info_link} onClick={openContactSales}>
                    <span>Contact sales</span>
                    <ChevronRightIcon />
                </div>
            </div>}

            <div className={styles.actions}>
                <Button
                    type='Outline-Dark'
                    text='Cancel'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setAddExtraMemberModal(false))}
                />
                <Button
                    type='Primary'
                    text='pay'
                    onClick={submit}
                    className={styles.actions_btn}
                    disabled={count === 0}
                />
            </div>
        </Modal>
    )
}
